import * as yup from 'yup';

export const initialValues = {
	disabilityType: '',
};

const schema =
yup.object().shape({
	disabilityType: yup.string().required('Tipo de deficiência é obrigatório!'),
});

export default schema;
